<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 详情页头部 -->
      <div class="page-card__header">
        信息详情
      </div>

      <!-- 信息详情内容 -->
      <div class="page-card__body" style="width: 800px; margin: 0 auto; padding-bottom: 100px">
        <div style="padding: 20px 0">
        </div>
        <div style="padding: 20px 0; font-weight: bold">{{ dataList.title }}</div>
        <div style="padding: 20px; width: 800px">
          <div v-html="dataList.info"></div>
        </div>

        <!-- 统计信息 -->
        <div style="margin: 40px 0">
          <el-row>
            <el-col :span="22" style="text-align: right">
              <div style="font-size: 14px; line-height: 40px">
                <i class="el-icon-view"></i> {{ dataList.view }}
              </div>
            </el-col>
            <el-col :span="2">
              <div style="font-size: 14px; line-height: 40px">
                点赞:{{ dataList.praise }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "infoDetail",
  data() {
    return {
      id: "",
      dataList: [],
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getNewData();
  },
  methods: {
    // 获取信息详情数据
    getNewData() {
      let id = this.id;
      let url = this.baseUrl + "/user/news/" + id + "/";
      api.fetchData(url).then((res) => {
        this.dataList = res;
      });
    },
  },
};
</script>

<style scoped>
#htmlImg {
  width: 800px;
}
::v-deep img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/infoDetail.vue